module.exports = __webpack_public_path__ + "img/jewelleryBackground@2x.49bdebd.jpg";